import React from 'react';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import MerchantRebateV2 from 'core/modules/MerchantRebateV2/MerchantRebateV2';
import dayjs from 'core/utils/dayjs';

function InfoBarSliderItem({
  offer, config, useAddToFavorite, shouldTrackInitialParams,
}) {
  const {
    id, assets, couponCode, merchant, isOngoing, isEndingSoon, isDealOfTheWeek, codeText, stopDatetime,
  } = offer;

  const {
    api: { options: apiOptions }, rebateOptions, dateFormat,
  } = config;
  const { getLabelText } = config;
  const { sectionId } = apiOptions;
  const { rolloverCopy } = assets;
  const { rebate } = merchant;
  const expiresToDisplay = dayjs.parseZone(stopDatetime).format(dateFormat);

  const labelText = getLabelText(isDealOfTheWeek);

  const getClassName = () => {
    const dealOfTheWeekClassName = isDealOfTheWeek ? 'mn_dealOfTheWeek' : '';

    return `mn_offer ${dealOfTheWeekClassName}`;
  };

  const renderOfferContent = () => (
    <div className="mn_offerWrap">
      {useAddToFavorite && <FavoriteIcon merchantId={merchant.id} merchantName={merchant.name} />}
      <OfferOverlayLink
        offerId={id}
        dealId={id}
        sectionId={sectionId}
        merchantId={merchant.id}
        merchantName={merchant.name}
        shouldTrackInitialParams={shouldTrackInitialParams}
      >
        <img
          className="mn_merchantLogo"
          src={merchant.logoUrls._120x60}
          alt={merchant.name}
        />

        <div className="mn_offerItemContent">
          <div className="mn_offerDetailsAndExpiryWrap">
            <p
              data-text={rolloverCopy}
              data-merchant-name={merchant.name}
              className="mn_rolloverCopy"
              dangerouslySetInnerHTML={{ __html: rolloverCopy }}
            />
            <span className={`mn_expire ${isEndingSoon ? 'mn_endingSoon' : ''}`}>
              {isOngoing ? 'Ongoing' : `Valid thru ${expiresToDisplay}`}
            </span>
          </div>

          <ExtraRewardsPill rebate={rebate} />

          <MerchantRebateV2 {...rebate} {...rebateOptions} hideRebatePrefix />
          {couponCode &&
            <div className="mn_couponCodeWrap">
              <span className="mn_couponCodeLabel">{codeText || 'Use code:'} </span>
              <p className="mn_couponCode">{couponCode}</p>
            </div>
          }
        </div>
      </OfferOverlayLink>
    </div>
  );

  return (
    <div
      className={getClassName()}
      data-is-dotw={isDealOfTheWeek}
      data-content-item-id={id}
      data-merchant-name={merchant.name}
      data-test="info-bar-slider"
    >
      <div className="mn_label">
        {labelText}
      </div>
      { renderOfferContent() }
    </div>
  );
}

export default InfoBarSliderItem;
